import * as Yup from 'yup';
import moment from 'moment-timezone';

export enum PREFERENCES_FORM_FIELDS {
	LANGUAGE = 'language',
	TIMEZONE = 'timezone',
	TIMEZONE_NANE = 'timezoneName',
}

export enum PREFERENCES_FORM_FIELDS_NAMES {
	LANGUAGE = 'Language',
	TIMEZONE = 'Time Zone',
}

export type PreferencesTypes = {
	[PREFERENCES_FORM_FIELDS.LANGUAGE]: string,
	[PREFERENCES_FORM_FIELDS.TIMEZONE]: string
	[PREFERENCES_FORM_FIELDS.TIMEZONE_NANE]?: string
};

export type PreferencesReturnTypes = {
	language: string,
	timezone: number,
	timezoneName?: string,
}

export const preferencesInitialValues: PreferencesTypes = {
	[PREFERENCES_FORM_FIELDS.LANGUAGE]: '',
	[PREFERENCES_FORM_FIELDS.TIMEZONE]: '',
	[PREFERENCES_FORM_FIELDS.TIMEZONE_NANE]: '',

};

// @ts-ignore
export const getPreferencesDetailsSchema = (): Yup.SchemaOf<PreferencesTypes> => Yup.object().shape({
	[PREFERENCES_FORM_FIELDS.LANGUAGE]: Yup.string()
		.required('Language is required'),
	[PREFERENCES_FORM_FIELDS.TIMEZONE]: Yup.string()
	.required('Timezone is required')
});

export const convertToInitial = (data): PreferencesTypes => ({
	[PREFERENCES_FORM_FIELDS.LANGUAGE]: data?.language ? data?.language : 'en',
	[PREFERENCES_FORM_FIELDS.TIMEZONE]: data?.timezoneName
});

export const getFormattedPreferencesFields = (formikValues): PreferencesReturnTypes => {
	const zone = formikValues?.[PREFERENCES_FORM_FIELDS.TIMEZONE];
	const offset = moment.tz(zone).utcOffset();
	return {
		language: formikValues?.[PREFERENCES_FORM_FIELDS.LANGUAGE],
		timezone: offset,
		timezoneName: zone
	};
};

export const getFormattedInitialPreferencesData = (data): PreferencesTypes => ({
	[PREFERENCES_FORM_FIELDS.LANGUAGE]: data?.language,
	[PREFERENCES_FORM_FIELDS.TIMEZONE]: data?.timezone,
	[PREFERENCES_FORM_FIELDS.TIMEZONE_NANE]: data?.timezoneName,
});
